export default __webpack_public_path__ + "static/udda_text-9196dd105dc061a202b2f4bcaa097534.jpg";